import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { PhoneFormatPipe } from '../_pipes/phone-format.pipe';

@Directive({
  selector: '[appPhoneMask]',
  standalone: true
})
export class PhoneMaskDirective {
  private phonePipe = new PhoneFormatPipe();

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any): void {
    const input = event.target as HTMLInputElement;
    const digitsOnly = input.value.replace(/\D/g, '');
    const formatted = this.phonePipe.transform(digitsOnly);

    input.value = formatted;

    this.control.control?.setValue(formatted);
  }
}
